/**
 @ngdoc service
 @name durationService

 @description
 Deals with complex duration fun
*/
var durationService = function(mathService) {

	this.MILLISECOND = 0;
	this.SECOND = 1;
	this.MINUTE = 2;
	this.HOUR = 3;
	this.DAY = 4;

	/**
	 * PRIVATE Takes a String and converts it into a Array
	 * e.g. ( '1stForKey1:1stForKey2,2ndForKey1:2ForKey2', ['key1','key2'] )
	 * returns [{key1:'1stForKey1',key2:'1stForKey2'},{key1:'2ndForKey1',key2:'2ForKey2'}]
	 * @param String value - String to be converted
	 * @param Array<String> keyNameList - name(s) you wish key to be labelled
	 * @return Array
	 */
	this._createPropertyKeyValueList = function(value,keyNameList){
		var unparsedValueList, unparsedValueSize, keyValue;

		var keyNameSize = keyNameList.length;
		var keyValueList = [];
		var unparsedList = value.split(',');

		for(var y=0,l=unparsedList.length;y<l;y++){
			unparsedValueList = unparsedList[y].split(':');
			unparsedValueSize = unparsedValueList.length;
			keyValue = {};
			for(var x=0;x<keyNameSize;x++){
				if( unparsedValueSize > x ){
					// keyValue[ keyName ] = value
					keyValue[ keyNameList[x] ] = unparsedValueList[x];
				} else {
					keyValue[ keyNameList[x] ] = null; //A key has been defined but value has not been defined!
				}
				if( unparsedValueSize > keyNameSize ){
					throw 'durationService._createPropertyKeyValueList() A value exists for which there is no key name for';
				}
			}
			keyValueList.push(keyValue);
		}
		return keyValueList;
	};

	/**
	 * Calculate the number of minutes between two times (represented as Date objects).
	 * Important Note: If the endTime:Date is less than the startTime:Date ,
	 * it will assume the endTime:Date is meant to be the next day and will adjust accordingly.
	 * @param Object:Date startTime - Start time represented as a Date object
	 * @param Object:Date endTime - End time represented as a Date object
	 * @return Number:Integer
	 */
	this.minutesBetween = function(startTime, endTime){
		//console.log('startTime',startTime);
		//console.log('endTime',endTime);
		var minutesBetween = 0;
		if(!(startTime==""||startTime==null||endTime==""||endTime==null)){
            //Collect milliseconds
            var startMilli = startTime.getTime();
            var endMilli = endTime.getTime();
            if(endTime<startTime){
                //if the end date is less than the start date then we've crossed into a new day
                var copyEndTime = new Date(endTime.getTime());
                copyEndTime.setDate(copyEndTime.getDate()+1);
                endMilli = copyEndTime.getTime();
            }
			minutesBetween = Math.floor((endMilli - startMilli )/1000/60);
		}
		return minutesBetween;
	};

	/**
	 * Hour and Minute duration methods
	 */
	this.dayHourMinute = {
		//Access to parent "class" methods and statics - like Java's import
		parentRef: this,
		DAY: this.DAY,
		HOUR: this.HOUR,
		MINUTE: this.MINUTE,

		/**
		 * Create a day:hour:minute duration object (Observing base 24 and base 60 numeric rules)
		 * @param Number:Integer days - number of days
		 * @param Number:Integer hour - number of hours
		 * @param Number:Integer minute - number of minutes
		 * @return Object{day:,hour:,minute:}
		 */
		duration: function(day, hour, minute){
			var hourNumberal = mathService.numeral(hour, minute, 60);
			var dayNumberal = mathService.numeral(day, hourNumberal.characteristic, 24);
			var duration = {
				day: dayNumberal.characteristic,
				hour: dayNumberal.mantissa,
				minute: hourNumberal.mantissa
			};
			return duration;
		}
	}

	/**
	 * Hour and Minute duration methods
	 */
	this.hourMinuteSecond = {
		//Access to parent "class" methods and statics - like Java's import
		parentRef: this,
		HOUR: this.HOUR,
		MINUTE: this.MINUTE,
		SECOND: this.SECOND,

		/**
		 * Create a hour:minute duration object (Observing base 60 numeric rules)
		 * @param Number:Integer hour - number of hours
		 * @param Number:Integer minute - number of minutes
		 * @param Number:Integer second - number of seconds
		 * @return Object{hour:,minute:,second:}
		 */
		duration: function(hour, minute, second){
			var minuteNumeral = mathService.numeral(minute, second, 60);
			var hourNumberal = mathService.numeral(hour, minuteNumeral.characteristic, 60);
			var duration = {
				hour: hourNumberal.characteristic,
				minute: hourNumberal.mantissa,
				second: minuteNumeral.mantissa
			};
			return duration;
		}
	}

	/**
	 * Hour and Minute duration methods
	 */
	this.hourMinute = {
		//Access to parent "class" methods and statics - like Java's import
		parentRef: this,
		HOUR: this.HOUR,
		MINUTE: this.MINUTE,

		/**
		 * Create a hour:minute duration object (Observing base 60 numeric rules)
		 * @param Number:Integer hour - number of hours
		 * @param Number:Integer minute - number of minutes
		 * @return Object{hour:,minute:}
		 */
		duration: function(hour, minute){
			var numeral = mathService.numeral(hour, minute, 60);
			var duration = {hour: numeral.characteristic, minute: numeral.mantissa};
			return duration;
		},

		/**
		 * Create a hour:minute duration object (Observing base 60 numeric rules) from a HH:mm String
		 * @param String time - time represented as HH:mm (hour:minute)
		 * @return Object{hour:,minute:}
		 */
		convertToDuration: function(time){
			var timeParts = time.split(':');
			var hour = 0;
			var minute = 0;
			if(timeParts.length==2){
				hour = parseInt(timeParts[0]);
				minute = parseInt(timeParts[1]);
			} else {
				throw 'durationService.hourMinute.convertToDuration() time provided is not in HH:mm format';
			}
			return this.duration( hour, minute );
		},

		/**
		 * Create a Date object (Observing base 60 numeric rules) from a HH:mm String
		 * @param String time - time represented as HH:mm (hour:minute)
		 * @return Object:date
		 */
		convertToDateTime: function(time){
			//JavaScript Dates start at January 1, 1970, 00:00:00 UTC
			var duration = this.convertToDuration(time);
			var date = new Date(1970,0,1,duration.hour,duration.minute, 0);
			return date;
		},

		/**
		 * Combine two hour:minute duration objects to make a new duration object (Observing base 60 numeric rules)
		 * @param Object{hour:,minute:} duration1 - hour:minute duration object
		 * @param Object{hour:,minute:} duration2 - hour:minute duration object
		 * @return Object{hour:,minute:}
		 */
		combine: function(duration1,duration2){
			return this.duration( duration1.hour+duration2.hour , duration1.minute+duration2.minute );
		},

		/**
		 * Add hours or minutes to a hour:minute duration object and make a new duration object (Observing base 60 numeric rules)
		 * @param Object{hour:,minute:} duration - hour:minute duration object
		 * @param Number:Integer number - amount of hours or minutes to be added to the duration object
		 * @param Number:Integer type - STATIC type of incrament durationService.HOUR || durationService.MINUTE
		 * @return Object{hour:,minute:}
		 */
		add: function(duration,number,type){
			//console.log('durationService.hourMinute.add() type:',type);
			//console.log('durationService.hourMinute.add() _this:',this._this);
			if(type==this.parentRef.MINUTE){
				//console.log('minute')
				duration.minute += number;
			} else if(type==this.parentRef.HOUR){
				//console.log('hour')
				duration.hour += number;
			} else {
				throw 'durationService.hourMinute.add() type used is undefined';
			}
			var outDuration = this.duration(duration.hour, duration.minute);
			return outDuration;
		},

		/**
		 * Subtract hours or minutes to a hour:minute duration object and make a new duration object (Observing base 60 numeric rules)
		 * @param Object{hour:,minute:} duration - hour:minute duration object
		 * @param Number:Integer number - amount of hours or minutes to be subtracted from the duration object
		 * @param Number:Integer type - STATIC type of decrament durationService.HOUR || durationService.MINUTE
		 * @return Object{hour:,minute:}
		 */
		subtract: function(duration,number,type){
			return this.add(duration,-number,type);
		},

		/**
		 * Calculate the difference between two dates and return as hour:minute duration object.
		 * Important Note: If the startTime:Date is less than the endTime:Date ,
		 * it will assume the endTime:Date is meant to be the next day and will adjust accordingly.
		 * @param Object:Date startTime - start time as a Date object
		 * @param Object:Date endTime - end time as a Date object
		 * @return Object{hour:,minute:}
		 */
		between: function(startTime, endTime){
			var minuteDifference = this.parentRef.minutesBetween(startTime, endTime);
			return this.duration( 0, minuteDifference );
		},

		/**
		 * Calculate the difference between two dates and add difference to provided
		 * hour:minute duration object return sum as hour:minute duration object.
		 * Important Note: If the startTime:Date is less than the endTime:Date ,
		 * it will assume the endTime:Date is meant to be the next day and will adjust accordingly.
		 * @param Object:{hour:,minute:} duration - hour:minute duration object
		 * @param Object:Date startTime - start time as a Date object
		 * @param Object:Date endTime - end time as a Date object
		 * @return Object{hour:,minute:}
		 */
		addDifferenceBetween: function(duration, startTime, endTime){
			var minuteDifference = this.parentRef.minutesBetween(startTime, endTime);
			return this.add( duration, minuteDifference, this.MINUTE );
		},

		/**
		 * Calculate the difference between two dates and subtract difference to provided
		 * hour:minute duration object return sum as hour:minute duration object.
		 * Important Note: If the startTime:Date is less than the endTime:Date ,
		 * it will assume the endTime:Date is meant to be the next day and will adjust accordingly.
		 * @param Object:{hour:,minute:} duration - hour:minute duration object
		 * @param Object:Date startTime - start time as a Date object
		 * @param Object:Date endTime - end time as a Date object
		 * @return Object{hour:,minute:}
		 */
		subtractDifferenceBetween: function(duration, startTime, endTime){
			var minuteDifference = this.parentRef.minutesBetween(startTime, endTime);
			return this.subtract( duration, minuteDifference, this.MINUTE );
		},

		propertyKey:{
			//declaring access to the private method - Think of it like Java's import
			parentRef: this,

			/**
			 * Takes a String and converts it into a key Array
			 * e.g. ( 'hour1:minute1,hour2:minute2' )
			 * returns [ {hour:'hour1',minute:'minute1'} , {hour:'hour2',minute:'minute2'} ]
			 * @param String attributeValue - String to be converted
			 * @return Array<{hour:,minute:}>
			 */
			createDuration: function(attributeValue){
				return this.parentRef._createPropertyKeyValueList(attributeValue,['hour','minute'])[0];
			}
		},

		propertyKeyList: {
			//declaring access to the private method - Think of it like Java's import
			parentRef: this,
			/**
			 * Takes a String and converts it into a key Array
			 * e.g. ( 'start1:end1,hour2:end2' )
			 * returns [ {start:'start1',end:'end1'} , {start:'start2',end:'end2'} ]
			 * @param String attributeValue - Attribute String to be converted
			 * @return Array<{start:,end:}>
			 */
			createTime: function(attributeValue){
				return this.parentRef._createPropertyKeyValueList(attributeValue,['start','end']);
			},

			/**
			 * Takes a String and converts it into a key Array
			 * e.g. ( 'hour1:minute1,hour2:minute2' )
			 * returns [ {hour:'hour1',minute:'minute1'} , {hour:'hour2',minute:'minute2'} ]
			 * @param String attributeValue - String to be converted
			 * @return Array<{hour:,minute:}>
			 */
			createDuration: function(attributeValue){
				return this.parentRef._createPropertyKeyValueList(attributeValue,['hour','minute']);
			}
		}
	}
}
durationService.$inject = ['mathService'];
angular.module('app').service('durationService', durationService);